<template v-if="!resultsStore.loading">
    <p v-if="resultsStore.hasErrored" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 mx-1">
        Oops! Our map of all things Illinois ran into an issue. Please refresh the page. Thanks for your patience!
    </p>
    <template v-else>
        <template v-if="resultsStore.pageInfo">
            <div class="hidden invisible justify-between items-center gap-1 pb-0 p-1 mb-1 bg-transparent md:flex md:visible">
                <ResultsHeader/>
            </div>
        </template>
        <div id="dottie-results-grid" class="grid grid-cols-[repeat(auto-fill,_minmax(300px,_1fr))] gap-0.75 xl:gap-1.5 p-1 pt-0">
            <div v-for="listing in resultsStore.listings" class="group listing-item relative">
                <div class="listing-image relative">
                    <div class="w-full overflow-hidden">
                        <img v-if="listing.node.image" :src="listing.node.image.urlForList" loading="lazy" class="w-full group-hover:opacity-70 group-hover:scale-[1.02] group-hover:ease-in-out duration-300"
                            alt="" width="340" height="212" />
                        <img v-else src="../../../../../images/no-image-small.webp" class="w-full group-hover:opacity-70 group-hover:scale-[1.02] group-hover:ease-in-out duration-300" loading="lazy" alt=""
                            width="340" height="212" />
                        </div>
                    <div v-if="listing.node.type == 'Event' && listing.node.futureOccurrences[0]?.startDate"
                        class="absolute shadow-lg  left-half bottom-half xl:left-0.75 xl:bottom-0.75 text-white [word-spacing:50px] xl:[word-spacing:60px]
                         bg-primary w-[50px] xl:w-[60px] xl:px-1 rounded-sm text-center text-sm xl:text-base font-bold p-half !leading-tight">
                        {{ listing.node.futureOccurrences[0].startDate }}
                    </div>

                    <span class="absolute shadow-sm bottom-[1.2rem] left-[2.95rem] xl:left-[3.9rem] w-[25px] h-[25px] z-[1] p-[0.2rem] xl:bottom-1.5 bg-primary-lightest text-primary text-xs font-serif rounded-full text-center"
                    v-if="listing.node.type == 'Event' && listing.node.futureOccurrences[0]?.endDate && listing.node.futureOccurrences[0].startDate != listing.node.futureOccurrences[0].endDate">
                       <em>to</em>
                    </span>

                    <div v-if="listing.node.type == 'Event' && listing.node.futureOccurrences[0]?.endDate && listing.node.futureOccurrences[0].startDate != listing.node.futureOccurrences[0].endDate"
                        class="absolute shadow-lg  left-4 bottom-half xl:left-5 xl:bottom-0.75 text-white [word-spacing:50px] xl:[word-spacing:60px]
                         bg-primary w-[50px] xl:w-[60px] xl:px-1 rounded-sm text-center text-sm xl:text-base font-bold p-half !leading-tight">
                         {{ listing.node.futureOccurrences[0].endDate }}
                    </div>

                    <div class="absolute -bottom-1.25 right-1 z-[5]">
                        <favourite-icon type="Listing" :key="listing.id" :id="listing.node.id"
                            :cssClasses="favButtonCssClasses" />
                    </div>
                </div>
                <strong v-if="listing.node.featured"
                    class="bg-primary text-white absolute top-1 px-[5px] py-[3px]">#featured</strong>
                <h3 class="text-base text-pretty mt-1 mb-half pr-4 group-hover:text-primary">
                    {{ listing.node.name }}
                </h3>
                <p v-if="listing.node.type != 'Event' && listing.node.city?.name"
                    class="flex mb-half  items-center text-sm gap-qtr">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="text-primary w-1.5 h-1.5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                    </svg>
                    <span class="text-gray-800">
                        {{ listing.node.city.name }}
                    </span>
                </p>
                <p v-if="listing.node.type == 'Event'" class="block mb-half text-pretty items-center text-sm gap-qtr">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="text-primary inline-block mr-qtr w-1.5 h-1.5">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                    </svg>
                    <span v-if="listing.node.venue">
                        {{ listing.node.venue }}
                    </span>
                    <span v-else-if="listing.node.city?.name">
                        {{ listing.node.city.name }}
                    </span>

                    <span v-if="listing.node.futureOccurrences[0]?.startDate">
                        &#149; {{ listing.node.futureOccurrences[0].startDate }}
                    </span>
                    <span
                        v-if="listing.node.futureOccurrences[0]?.endDate && listing.node.futureOccurrences[0].startDate != listing.node.futureOccurrences[0].endDate">
                        - {{ listing.node.futureOccurrences[0].endDate }}
                    </span>
                    <span v-if="listing.node.futureOccurrences[0]?.startTimeNice">
                        &#149; {{ listing.node.futureOccurrences[0].startTimeNice }}
                    </span>
                    <span
                        class="text-primary text-nowrap ml-half font-bold text-xs bg-primary-lighter rounded py-[3px] px-[5px]"
                        v-if="listing.node.futureOccurrences?.length > 1">
                        Additional Dates
                    </span>
                </p>
                <p v-if="listing.node.limitedSummary" class="text-sm text-lightgray text-pretty">
                    {{ listing.node.limitedSummary }}
                </p>
                <a :href="buildListingLink(listing.node.urlSlug)" class="absolute inset-0 z-[2]">
                    <span class="sr-only">Read more about {{ listing.node.name }}</span>
                </a>
            </div>
        </div>
    </template>
</template>

<div class="grid grid-cols-[repeat(auto-fill,_minmax(300px,_1fr))] gap-0.75 xl:gap-1.5 p-1 pt-0 mt-4" v-else>
    <div class="animate-pulse flex space-x-1">
        <div class="flex-1 space-y-1 py-1">
            <div class="aspect-video bg-slate-300 rounded"></div>
            <div class="space-y-1">
                <div class="grid grid-cols-3 gap-1">
                    <div class="h-2 bg-slate-300 rounded col-span-2"></div>
                    <div class="h-2 bg-slate-300 rounded col-span-1"></div>
                </div>
                <div class="h-3 bg-slate-300 rounded"></div>
            </div>
        </div>
    </div>

    <div class="animate-pulse flex space-x-1 delay-75">
        <div class="flex-1 space-y-1 py-1">
            <div class="aspect-video bg-slate-300 rounded"></div>
            <div class="space-y-1">
                <div class="grid grid-cols-3 gap-1">
                    <div class="h-2 bg-slate-300 rounded col-span-2"></div>
                    <div class="h-2 bg-slate-300 rounded col-span-1"></div>
                </div>
                <div class="h-3 bg-slate-300 rounded"></div>
            </div>
        </div>
    </div>

    <div class="animate-pulse flex space-x-1 delay-100">
        <div class="flex-1 space-y-1 py-1">
            <div class="aspect-video bg-slate-300 rounded"></div>
            <div class="space-y-1">
                <div class="grid grid-cols-3 gap-1">
                    <div class="h-2 bg-slate-300 rounded col-span-2"></div>
                    <div class="h-2 bg-slate-300 rounded col-span-1"></div>
                </div>
                <div class="h-3 bg-slate-300 rounded"></div>
            </div>
        </div>
    </div>

    <div class="animate-pulse flex space-x-1 delay-150">
        <div class="flex-1 space-y-1 py-1">
            <div class="aspect-video bg-slate-300 rounded"></div>
            <div class="space-y-1">
                <div class="grid grid-cols-3 gap-1">
                    <div class="h-2 bg-slate-300 rounded col-span-2"></div>
                    <div class="h-2 bg-slate-300 rounded col-span-1"></div>
                </div>
                <div class="h-3 bg-slate-300 rounded"></div>
            </div>
        </div>
    </div>

    <div class="animate-pulse flex space-x-1 delay-100">
        <div class="flex-1 space-y-1 py-1">
            <div class="aspect-video bg-slate-300 rounded"></div>
            <div class="space-y-1">
                <div class="grid grid-cols-3 gap-1">
                    <div class="h-2 bg-slate-300 rounded col-span-2"></div>
                    <div class="h-2 bg-slate-300 rounded col-span-1"></div>
                </div>
                <div class="h-3 bg-slate-300 rounded"></div>
            </div>
        </div>
    </div>

    <div class="animate-pulse flex space-x-1 delay-150">
        <div class="flex-1 space-y-1 py-1">
            <div class="aspect-video bg-slate-300 rounded"></div>
            <div class="space-y-1">
                <div class="grid grid-cols-3 gap-1">
                    <div class="h-2 bg-slate-300 rounded col-span-2"></div>
                    <div class="h-2 bg-slate-300 rounded col-span-1"></div>
                </div>
                <div class="h-3 bg-slate-300 rounded"></div>
            </div>
        </div>
    </div>

    <div class="animate-pulse flex space-x-1 delay-100">
        <div class="flex-1 space-y-1 py-1">
            <div class="aspect-video bg-slate-300 rounded"></div>
            <div class="space-y-1">
                <div class="grid grid-cols-3 gap-1">
                    <div class="h-2 bg-slate-300 rounded col-span-2"></div>
                    <div class="h-2 bg-slate-300 rounded col-span-1"></div>
                </div>
                <div class="h-3 bg-slate-300 rounded"></div>
            </div>
        </div>
    </div>

    <div class="animate-pulse flex space-x-1 delay-150">
        <div class="flex-1 space-y-1 py-1">
            <div class="aspect-video bg-slate-300 rounded"></div>
            <div class="space-y-1">
                <div class="grid grid-cols-3 gap-1">
                    <div class="h-2 bg-slate-300 rounded col-span-2"></div>
                    <div class="h-2 bg-slate-300 rounded col-span-1"></div>
                </div>
                <div class="h-3 bg-slate-300 rounded"></div>
            </div>
        </div>
    </div>


</div>
